<!-- Main container -->
<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table
      class="flex"
      matSort
      [data]="data"
      [idField]="'id'"
      (itemClick)="openDetail($event)"
    >
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="create()"
        [canRemove]="false"
        [canAdd]="true"
        [canMore]="false"
      >
        <ng-template elderToolbarContent="center">
          <elder-search-box
            dense
            class="flex-60 pt-xs"
            queryKey="query"
            [autoPanel]="false"
            [elderSearchContext]="data.filter"
          >
          </elder-search-box>
        </ng-template>
      </elder-data-toolbar>

      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon>label</mat-icon>
        </td>
      </ng-container>

      <!-- abbreviation Column -->
      <ng-container matColumnDef="abbreviation">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'context.abbreviation' | translate }}
        </th>
        <td mat-cell *matCellDef="let type">{{ type.abbreviation }}</td>
      </ng-container>

      <!-- type Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'context.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let type">{{ type.name }}</td>
      </ng-container>

      <!--TODO the names of the specifications would have to be loaded separately -->

      <!-- description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef style="width: 40%" mat-sort-header>
          {{ 'context.description' | translate }}
        </th>
        <td mat-cell *matCellDef="let type">{{ type.description }}</td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
